// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import { AnonymousIdentity, AnonymousIdentityT } from "./anonymous-identity";
import { UserNameIdentity, UserNameIdentityT } from "./user-name-identity";
import { X509Identity, X509IdentityT } from "./x509-identity";

/**
 * User identity token presented when activating the session.
 */
export enum Identity {
  NONE = 0,
  AnonymousIdentity = 1,
  UserNameIdentity = 2,
  X509Identity = 3,
}

export function unionToIdentity(
  type: Identity,
  accessor: (
    obj: AnonymousIdentity | UserNameIdentity | X509Identity,
  ) => AnonymousIdentity | UserNameIdentity | X509Identity | null,
): AnonymousIdentity | UserNameIdentity | X509Identity | null {
  switch (Identity[type]) {
    case "NONE":
      return null;
    case "AnonymousIdentity":
      return accessor(new AnonymousIdentity())! as AnonymousIdentity;
    case "UserNameIdentity":
      return accessor(new UserNameIdentity())! as UserNameIdentity;
    case "X509Identity":
      return accessor(new X509Identity())! as X509Identity;
    default:
      return null;
  }
}

export function unionListToIdentity(
  type: Identity,
  accessor: (
    index: number,
    obj: AnonymousIdentity | UserNameIdentity | X509Identity,
  ) => AnonymousIdentity | UserNameIdentity | X509Identity | null,
  index: number,
): AnonymousIdentity | UserNameIdentity | X509Identity | null {
  switch (Identity[type]) {
    case "NONE":
      return null;
    case "AnonymousIdentity":
      return accessor(index, new AnonymousIdentity())! as AnonymousIdentity;
    case "UserNameIdentity":
      return accessor(index, new UserNameIdentity())! as UserNameIdentity;
    case "X509Identity":
      return accessor(index, new X509Identity())! as X509Identity;
    default:
      return null;
  }
}

export type IdentityT =
  | { type: "NONE"; value: null }
  | { type: "AnonymousIdentity"; value: AnonymousIdentityT }
  | { type: "UserNameIdentity"; value: UserNameIdentityT }
  | { type: "X509Identity"; value: X509IdentityT };
